module.exports = __webpack_public_path__ + "static/nxrt-background-974ae5ab59cb0e6f314abf55cf3e64dd.svg";